<template lang="pug">
    section#curriculo.conteudoEgressos
        div.wrapper(v-if="conteudo != null", :class="{noflex: conteudo.has_titulo}")
            hr.hrDesenvolvimento
            h2(v-if="conteudo.has_titulo") {{ conteudo.titulo }}
            div(v-html="conteudo.conteudo", v-if="conteudo != null").conteudo
</template>

<script>
export default {
    name: "section-curriculo",
    props:{
        conteudo: Object,
    }
}
</script>

<style lang="stylus" scoped src="./Curriculo.styl"></style>